import qs from 'qs';
import { network } from 'services/network';

export const updateTag = ({ customerId, oldName, newName, projectId }: QueryParams) => {
    const querystring = qs.stringify(
        { customerId, oldName, newName, projectId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/updateTag${querystring}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
